import Swiper, { Pagination, Mousewheel } from 'swiper';

function initializeProductBoxesBlock(root) {
    if (!root || root.dataset.productBoxesInitialized === 'true') {
        return;
    }

    const swiperContainer = root.querySelector('.product-boxes__swiper');

    if (!swiperContainer) {
        return;
    }

    root.dataset.productBoxesInitialized = 'true';

    const view = root.ownerDocument.defaultView;

    const state = {
        swiper: null,
    };

    const initSwiper = () => {
        state.swiper = new Swiper(swiperContainer, {
            modules: [Pagination, Mousewheel],
            spaceBetween: 15,
            loop: false,
            observer: true,
            slidesPerView: 'auto',
            allowTouchMove: true,
            mousewheel: {
                forceToAxis: true,
            },
            pagination: {
                el: swiperContainer.querySelector('.swiper-pagination'),
                clickable: true,
            }
        });
    };

    const swiperSwitcher = () => {
        if (view.matchMedia('(min-width:991px)').matches === true) {
            if (state.swiper) {
                state.swiper.destroy();
            }
        } else {
            if (!state.swiper || state.swiper.destroyed === true) {
                initSwiper();
            }
        }
    };

    swiperSwitcher();
    view.addEventListener('resize', swiperSwitcher);
}

function initializeFrontend() {
    document.querySelectorAll('.product-boxes').forEach(initializeProductBoxesBlock);
}

if (window.acf) {
    window.acf.addAction('render_block_preview/type=product-boxes', ($block) => {
        initializeProductBoxesBlock($block.get(0));
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFrontend);
} else {
    initializeFrontend();
}
